export const setOnboardingStorage = (key: string, value: any) => {
    const onboardingStorage = localStorage.getItem("onboarding");
    if (onboardingStorage) {
        const onboardingData = JSON.parse(onboardingStorage);
        onboardingData[key] = value;
        localStorage.setItem("onboarding", JSON.stringify(onboardingData));
    } else {
        const onboardingData = { [key]: value };
        localStorage.setItem("onboarding", JSON.stringify(onboardingData));
    }
};

export const getOnboardingStorage = (key: string) => {
    const onboardingStorage = localStorage.getItem("onboarding");
    if (onboardingStorage) {
        const onboardingData = JSON.parse(onboardingStorage);
        return onboardingData[key];
    }
    return null;
};

export const getAllOnboardingStorage = () => {
    const onboardingStorage = localStorage.getItem("onboarding");
    if (onboardingStorage) {
        return JSON.parse(onboardingStorage);
    }
    return null;
};

export const removeAllOnboardingStorage = () => {
    localStorage.removeItem("onboarding");
};
